module.exports = __webpack_public_path__ + "assets/img/card_img.68971b34.png";